function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.0793 10.47C18.0989 8.91364 18.1107 7.35333 18.0871 6.99175C17.8591 3.44272 14.7975 0.432128 11.1227 0.137358C10.8908 0.117708 10.6628 0.109848 10.4349 0.105918C8.43042 0.0862681 6.66181 0.711178 5.17618 1.96886C3.70233 3.21476 2.73548 5.05412 2.58612 6.88169C2.55862 7.21184 2.55469 8.86648 2.55862 10.47C1.09655 10.7609 0 12.0068 0 13.5003V27.209C0 28.9187 1.43848 30.3061 3.21497 30.3061H17.4425C19.219 30.3061 20.6575 28.9187 20.6575 27.209V13.5042C20.6536 12.0068 19.5492 10.7569 18.0793 10.47L18.0793 10.47ZM10.2109 3.29337C10.2659 3.29337 10.3209 3.29337 10.372 3.29337C11.9323 3.30909 13.2961 4.07942 14.1215 5.40785C14.5813 6.15067 14.7464 8.33197 14.7896 10.4071H5.86005C5.91507 8.3752 6.07621 6.14673 6.50068 5.45108C7.32212 4.11479 8.67411 3.32874 10.2108 3.29337H10.2109Z",
  fill: "#482474"
});

var SvgOneucLock = function SvgOneucLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 31,
    viewBox: "0 0 21 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOneucLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oneucLock.f6d78962.svg";
export { ForwardRef as ReactComponent };